import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./MultiuserDashboard.css";
import IntakeFormService from "../../services/intakeFormService";
import img from "../../images/profile.png";
import logo from "../../images/logo.png";
import mainLogo from "../../images/logoWide.png";

const MultiuserDashboard = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [client, setClient] = useState("");
  const intakeFormService = new IntakeFormService();
  const [selectedId, setSelectedId] = useState("");

  const handleDropdownItemClick = (id) => {
    setSelectedId(id);
    const newURL = `/${id}`;
    navigate(newURL);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const clientData = await intakeFormService.getAccount();
        if (clientData.clients?.length > 0) {
          const clientId = clientData.clients[0].clientId;
          setSelectedId(clientId);
          setClient(clientData);
        }
      } catch (error) {
        console.error("Error fetching client data:", error);
      }finally{
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="parent-container">
      <div className="main">
        {isLoading && (
          <div className="loading-overlay">
            <Spinner animation="border" variant="light"></Spinner>
          </div>
        )}
        <div className="logo-container">
          <img src={mainLogo} alt="Speech4all" className="main-logo" />
        </div>
        <div className="title-profiles">Profiles</div>
        <Row className="client-row" style={{ gap: "120px" }}>
          {client?.clients?.map((box) => (
            <Col key={box.id}>
              <div
                className="user-card"
                onClick={() => handleDropdownItemClick(box.clientId)}
              >
                <div className="user-image">
                  {img ? (
                    <img src={img} alt="" className="rounded-circle" />
                  ) : (
                    <img src={""} className="img-placeholder" />
                  )}
                </div>
                <div className="names">
                  <span className="patient-name text-ellipsis">
                    {box.firstName} {box.lastName}
                    <br />
                    {box.dob}
                  </span>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default MultiuserDashboard;
